export enum ApiRequestStatus {
  pending = "pending",
  loading = "loading",
  error = "error",
  success = "success",
}
